import React from 'react';
import * as Yup from 'yup';

import Input from '../../../../../../newComponents/UnformInput';

import { Container } from './styles';

export const DimensionsFormSchema = Yup.object().shape({
  height: Yup.number()
    .min(0, 'Altura inválida')
    .nullable(true)
    .transform((_, value) => (value ? Number(value) : null)),
  width: Yup.number()
    .min(0, 'Largura inválida')
    .nullable(true)
    .transform((_, value) => (value ? Number(value) : null)),
  length: Yup.number()
    .min(0, 'Comprimento inválido')
    .nullable(true)
    .transform((_, value) => (value ? Number(value) : null)),
  weight: Yup.number()
    .min(0, 'Peso inválido')
    .nullable(true)
    .transform((_, value) => (value ? Number(value) : null)),
});

const Dimensions: React.FC = () => {
  return (
    <Container>
      <Input
        id="simpleProductHeight"
        suffix="CM"
        name="height"
        type="number"
        label="Altura"
        placeholder="Ex.: 12,50"
        step="0.1"
      />
      <Input
        id="simpleProductWidth"
        suffix="CM"
        name="width"
        type="number"
        label="Largura"
        placeholder="Ex.: 20,00"
        step="0.1"
      />
      <Input
        id="simpleProductLength"
        suffix="CM"
        name="length"
        type="number"
        label="Comprimento"
        placeholder="Ex.: 103,50"
        step="0.1"
      />
      <Input
        id="simpleProductWeight"
        suffix="KG"
        label="Peso"
        name="weight"
        type="number"
        placeholder="Ex.: 48,00"
        step="0.1"
      />
    </Container>
  );
};

export default Dimensions;
